import axios from "axios";
import {takeLatest, call, put, select, all} from "redux-saga/effects";
import {createAction} from "redux-actions";
import {queryParams} from "../../../../../../../utils/queryParams.js";
import {getCheckedFilters} from "../../../../../../../utils/formatters";
import moment from "moment";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_FILTERS_LOADING = "saga/SET_FILTERS_LOADING";
export const SET_SITE_FILTERS_LOADING = "saga/SET_SITE_FILTERS_LOADING";
export const SET_LOCATION_FILTERS_LOADING = "saga/SET_LOCATION_FILTERS_LOADING";
export const SET_FILTERS_DIRTY = "saga/SET_FILTERS_DIRTY";
export const SET_TABLES_LOADING = "saga/SET_TABLES_LOADING";
export const SET_DATES = "saga/SET_DATES";
export const UPDATE_DATES = "saga/UPDATE_DATES";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
export const UPDATE_REGIONS = "saga/UPDATE_REGIONS";
export const UPDATE_SITES = "saga/UPDATE_SITES";
export const UPDATE_LOCATIONS = "saga/UPDATE_LOCATIONS";
export const UPDATE_TABLES = "saga/UPDATE_TABLES";

export const FETCH_FILTERS_SUCCESS = "saga/FETCH_FILTERS_SUCCESS";
export const FETCH_FILTERS_EXCLUDE_SITES_SUCCESS = "saga/FETCH_FILTERS_EXCLUDE_SITES_SUCCESS";
export const FETCH_FILTERS_FAILURE = "saga/FETCH_FILTERS_FAILURE";

export const FETCH_TABLE_DATA = "saga/FETCH_TABLE_DATA";
export const FETCH_TABLE_DATA_SUCCESS = "saga/FETCH_TABLE_DATA_SUCCESS";
export const FETCH_TABLE_DATA_FAILURE = "saga/FETCH_TABLE_DATA_FAILURE";

export const FETCH_INTROS_CONVERSIONS = "saga/FETCH_INTROS_CONVERSIONS";
export const FETCH_INTROS_CONVERSIONS_SUCCESS = "saga/FETCH_INTROS_CONVERSIONS_SUCCESS";
export const FETCH_INTROS_CONVERSIONS_FAILURE = "saga/FETCH_INTROS_CONVERSIONS_FAILURE";

export const FETCH_FIRST_VISITS = "saga/FETCH_FIRST_VISITS";
export const FETCH_FIRST_VISITS_SUCCESS = "saga/FETCH_FIRST_VISITS_SUCCESS";
export const FETCH_FIRST_VISITS_FAILURE = "saga/FETCH_FIRST_VISITS_FAILURE";

export const FETCH_ALL_REVENUE = "saga/FETCH_ALL_REVENUE";
export const FETCH_ALL_REVENUE_SUCCESS = "saga/FETCH_ALL_REVENUE_SUCCESS";
export const FETCH_ALL_REVENUE_FAILURE = "saga/FETCH_ALL_REVENUE_FAILURE";

export const FETCH_LEADS = "saga/FETCH_LEADS";
export const FETCH_LEADS_SUCCESS = "saga/FETCH_LEADS_SUCCESS";
export const FETCH_LEADS_FAILURE = "saga/FETCH_LEADS_FAILURE";

export const FETCH_MEMBERSHIPS = "saga/FETCH_MEMBERSHIPS";
export const FETCH_MEMBERSHIPS_SUCCESS = "saga/FETCH_MEMBERSHIPS_SUCCESS";
export const FETCH_MEMBERSHIPS_FAILURE = "saga/FETCH_MEMBERSHIPS_FAILURE";

export const FETCH_AVERAGES = "saga/FETCH_AVERAGES";
export const FETCH_AVERAGES_SUCCESS = "saga/FETCH_AVERAGES_SUCCESS";
export const FETCH_AVERAGES_FAILURE = "saga/FETCH_AVERAGES_FAILURE";

export const UPDATE_CUSTOM_RANGE = "sagas/UPDATE_CUSTOM_RANGE";
export const UPDATE_CUSTOM_RANGE_ACTION = "sagas/UPDATE_CUSTOM_RANGE";

// const axios = defaultNetworkService()
export const actionCreators = {
  fetchTableData: createAction(FETCH_TABLE_DATA),
  updateDates: createAction(UPDATE_DATES),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateRegions: createAction(UPDATE_REGIONS),
  updateSites: createAction(UPDATE_SITES),
  updateLocations: createAction(UPDATE_LOCATIONS),
  requestNewTableData: createAction(UPDATE_TABLES),
  updateFiltersRequest: createAction(UPDATE_FILTERS)
};

export default function* watchSummary() {
  yield takeLatest(FETCH_TABLE_DATA, getTableData);
  yield takeLatest(UPDATE_TABLES, updateTables);
  yield takeLatest(UPDATE_FILTERS, updateFilters);
}

function getIds(data) {
  let ids = "";
  data.map(item => {
    ids = ids + `${item.id},`;
  });
  return ids;
}

export function* getTableData(data) {
  yield put({type: SET_LOADING, payload: true});
  yield put({type: SET_FILTERS_DIRTY, payload: true});
  yield put({type: SET_FILTERS_LOADING, payload: true});
  yield put({type: FETCH_TABLE_DATA_SUCCESS, payload: data.payload});

  const endDate = yield select(state => state.multiLocation.currentUser.params.calendarEndDate);
  const startDate = moment(endDate)
    .startOf("month")
    .format("YYYY-MM-DD");
  yield put({
    type: SET_DATES,
    payload: {
      startDate: startDate,
      endDate: endDate
    }
  });

  // let minumumReportDate = yield select(state => state.multiLocation.currentUser.params.calendarEndDate)
  let id = yield select(state => state.multiLocation.currentUser.params.organization_id);
  let regions = yield select(state => state.multiLocation.currentUser.params.filters.regions);
  let sites = yield select(state => state.multiLocation.currentUser.params.filters.objects);
  let locations = yield select(state => state.multiLocation.currentUser.params.filters.locations);

  let allSagas = [
    getFirstVisits(id, sites, getCheckedFilters(locations), regions, startDate, endDate),
    getAllRevenueData(id, sites, getCheckedFilters(locations), regions, startDate, endDate),
    getLeads(id, sites, getCheckedFilters(locations), regions, startDate, endDate),
    getIntrosConversions(id, sites, getCheckedFilters(locations), regions, startDate, endDate),
    getMemberships(id, sites, getCheckedFilters(locations), regions, startDate, endDate),
    getAverages(id, sites, getCheckedFilters(locations), regions, startDate, endDate),
    getFilters(id, -1, -1, -1)
  ];
  try {
    // effects will get executed in parallel
    yield all(allSagas);
    yield put({type: SET_LOADING, payload: false});
  } catch (error) {
    console.error(error);
  }
}

export function* updateCustomRange(payload) {
  yield put({
    type: UPDATE_CUSTOM_RANGE,
    payload: payload
  });
}

export function* updateDates(payload) {
  yield put({type: UPDATE_DATES, payload: payload});
}

export function* updateRegions(payload) {
  yield put({type: UPDATE_REGIONS, payload: payload});
}

export function* updateSites(payload) {
  yield put({type: UPDATE_SITES, payload: payload});
}

export function* updateLocations(payload) {
  yield put({type: UPDATE_LOCATIONS, payload: payload});
}

export function* updateFilters(payload) {
  let id = yield select(state => state.multiLocation.currentUser.params.organization_id);
  let regionId = yield select(state => state.multiLocation.selectedRegions);
  if (payload.payload.name === "Region") {
    yield put({type: SET_SITE_FILTERS_LOADING, payload: true});
    yield put({type: SET_LOCATION_FILTERS_LOADING, payload: true});
    const getFiltersSaga = getFiltersByRegion(id, payload.payload.data);
    yield getFiltersSaga;
  }
  if (payload.payload.name === "Site") {
    yield put({type: SET_LOCATION_FILTERS_LOADING, payload: true});
    const getFiltersSaga = getFiltersBySite(id, regionId, payload.payload.data);
    yield getFiltersSaga;
  }
}

export function* updateTables() {
  yield put({type: SET_TABLES_LOADING, payload: true});

  let id = yield select(state => state.multiLocation.currentUser.params.organization_id);
  let objectId = yield select(state => state.multiLocation.selectedSites);
  let locationId = yield select(state => state.multiLocation.selectedLocations);
  let regionId = yield select(state => state.multiLocation.selectedRegions);
  let startDate = yield select(state => state.multiLocation.selectedRequestDates.startDate);
  let endDate = yield select(state => state.multiLocation.selectedRequestDates.endDate);

  let allSagas = [
    getFirstVisits(id, objectId, locationId, regionId, startDate, endDate),
    getAllRevenueData(id, objectId, locationId, regionId, startDate, endDate),
    getLeads(id, objectId, locationId, regionId, startDate, endDate),
    getIntrosConversions(id, objectId, locationId, regionId, startDate, endDate),
    getMemberships(id, objectId, locationId, regionId, startDate, endDate),
    getAverages(id, objectId, locationId, regionId, startDate, endDate)
  ];
  try {
    // effects will get executed in parallel
    yield all(allSagas);
    yield put({type: SET_TABLES_LOADING, payload: false});
  } catch (error) {
    console.error(error);
  }
}

export function* getIntrosConversions(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_spenga_specific_conversion", {
      organization_id: id.toString(),
      location_id: getIds(locationId),
      region_id: getIds(regions),
      object_id: getIds(objectId),
      start_date: startDate,
      end_date: endDate
    });
    yield put({type: FETCH_INTROS_CONVERSIONS_SUCCESS, payload: response.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_INTROS_CONVERSIONS_FAILURE, error});
  }
}

export function* getFirstVisits(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_first_visits", {
      organization_id: id.toString(),
      location_id: getIds(locationId),
      region_id: getIds(regions),
      object_id: getIds(objectId),
      start_date: startDate,
      end_date: endDate
    });
    yield put({type: FETCH_FIRST_VISITS_SUCCESS, payload: response.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_FIRST_VISITS_FAILURE, error});
  }
}

export function* getAllRevenueData(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_revenue", {
      organization_id: id.toString(),
      location_id: getIds(locationId),
      region_id: getIds(regions),
      object_id: getIds(objectId),
      start_date: startDate,
      end_date: endDate
    });
    yield put({type: FETCH_ALL_REVENUE_SUCCESS, payload: response.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_ALL_REVENUE_FAILURE, error});
  }
}

export function* getLeads(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_leads", {
      organization_id: id.toString(),
      location_id: getIds(locationId),
      region_id: getIds(regions),
      object_id: getIds(objectId),
      start_date: startDate,
      end_date: endDate
    });
    yield put({type: FETCH_LEADS_SUCCESS, payload: response.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_LEADS_FAILURE, error});
  }
}

export function* getMemberships(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_spenga_specific_membership", {
      organization_id: id.toString(),
      location_id: getIds(locationId),
      region_id: getIds(regions),
      object_id: getIds(objectId),
      start_date: startDate,
      end_date: endDate
    });
    yield put({type: FETCH_MEMBERSHIPS_SUCCESS, payload: response.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_MEMBERSHIPS_FAILURE, error});
  }
}

export function* getAverages(id, objectId, locationId, regions, startDate, endDate) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_spenga_averages", {
      organization_id: id.toString(),
      location_id: getIds(locationId),
      region_id: getIds(regions),
      object_id: getIds(objectId),
      start_date: startDate,
      end_date: endDate
    });
    yield put({type: FETCH_AVERAGES_SUCCESS, payload: response.data});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_AVERAGES_FAILURE, error});
  }
}

export function* getFilters(id, regions, objectId, locationId) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_filters", {
      organization_id: id.toString(),
      location_id: locationId.toString(),
      region_id: regions.toString(),
      object_id: objectId.toString()
    });
    yield put({type: FETCH_FILTERS_SUCCESS, payload: response.data});
  } catch (error) {
    console.log("fetch filters error:", error);
    yield put({type: FETCH_FILTERS_FAILURE, error});
  }
}

export function* getFiltersByRegion(id, regions) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_filters", {
      organization_id: id.toString(),
      region_id: getIds(regions)
    });
    yield put({type: FETCH_FILTERS_SUCCESS, payload: response.data});
    yield put({type: UPDATE_SITES, payload: response.data.filters.objects});
    yield put({type: UPDATE_LOCATIONS, payload: response.data.filters.locations});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_FILTERS_FAILURE, error});
  }
}

export function* getFiltersBySite(id, regions, objectId) {
  try {
    const response = yield call(axios.post, queryParams.apiVersion + "reports/multi_location_dash_report/get_filters", {
      organization_id: id.toString(),
      region_id: getIds(regions),
      object_id: getIds(objectId)
    });
    yield put({type: FETCH_FILTERS_EXCLUDE_SITES_SUCCESS, payload: response.data});
    yield put({type: UPDATE_LOCATIONS, payload: response.data.filters.locations});
  } catch (error) {
    console.error(error);
    yield put({type: FETCH_FILTERS_FAILURE, error});
  }
}
